import { render, staticRenderFns } from "./CharacterEdit.vue?vue&type=template&id=a2b564be"
import script from "./CharacterEdit.vue?vue&type=script&lang=js"
export * from "./CharacterEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports